// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  MenuItem,
  Select,
} from "@mui/material";
import SoftBox from "../../components/common/softBox";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import { Loader } from "../../components/common/loader";
import SoftTypography from "../../components/common/softTypography";
import { FaEye } from "react-icons/fa6";
import SoftBadge from "../../components/common/softBadge";
import { IOrderItem } from "../../types/features/orderRequestsSlice";
import {
  createReturnSalesOrderData,
  getReturnSalesOrderByIdData,
  updateReturnSalesOrderData,
} from "../../features/returnSalesOrder";
import SoftInput from "../../components/common/softInput";
import SoftButton from "../../components/common/softButton";
import { prepareReturnOrderData } from "../../utils/commonHelper";
import { toast } from "react-toastify";
import ImageGallery from "react-image-gallery";
import {
  getSapOrderConfig,
  getSapPlantStorage,
} from "../../features/sapConfig";
import { useAppSelector } from "../../Hooks";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ViewReturnSalesOrder = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { detail: detailsData, returnSalesOrderLoader } = useSelector(
    (state: any) => state.returnSalesOrder
  );

  const [detail, setDetail] = useState<ISalesOrder>({});
  const [openGallery, setOpenGallery] = useState(false);

  const [salesOrg, setSalesOrg] = useState([]);
  const { sapOrderConfigData, plantStorageData } = useAppSelector(
    (state: any) => state.sapConfig
  );
  const [selectedSalesOrg, setSelectedSalesOrg] = useState("");
  const [distChannel, setDistChannel] = useState([]);
  const [selectedDistChannel, setSelectedDistChannel] = useState("");
  const [division, setDivision] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState("");
  const [plant, setPlant] = useState([]);
  // Per-row store location options
  const [storLocs, setStorLocs] = useState<{ [key: number]: any[] }>({});

  useEffect(() => {
    if (id) {
      dispatch(getReturnSalesOrderByIdData({ id }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (detail?.BusPartner && detail?.CompanyCode) {
      dispatch(
        getSapOrderConfig({
          filter: `BusPartner eq '${detail.BusPartner}' and CompCode eq '${detail.CompanyCode}'`,
        })
      );
      dispatch(
        getSapPlantStorage({
          filter: `CompanyCode eq '${detail?.CompanyCode}'`,
        })
      );
    }
  }, [detail?.BusPartner, detail?.CompanyCode]);

  useEffect(() => {
    if (sapOrderConfigData && sapOrderConfigData.length > 0) {
      setSelectedSalesOrg(sapOrderConfigData[0].SalesOrg);

      const distChannelTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter((i) => i.SalesOrg === sapOrderConfigData[0].SalesOrg)
            .map((i) => i.DistChannel)
        )
      ).map((dc) => ({ value: dc, label: dc }));
      setSelectedDistChannel(distChannelTemp[0].value);
      setDistChannel(distChannelTemp);

      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === sapOrderConfigData[0].SalesOrg &&
                i.DistChannel === distChannelTemp[0].value
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setSelectedDivision(divisionTemp[0].value);
      setDetail({
        ...detail,
        Division: divisionTemp[0].value,
        SalesOrg: sapOrderConfigData[0].SalesOrg,
        DistChannel: distChannelTemp[0].value,
      });
      setDivision(divisionTemp);

      const uniqueSalesOrgs = Array.from(
        new Set(sapOrderConfigData.map((item) => item.SalesOrg))
      );
      const options = uniqueSalesOrgs.map((org) => ({
        value: org,
        label: org,
      }));
      setSalesOrg(options);
    }
  }, [sapOrderConfigData]);

  useEffect(() => {
    if (plantStorageData && plantStorageData.length > 0) {
      const uniquePlant = Array.from(
        new Set(plantStorageData.map((item) => item.Plant))
      );
      const options = uniquePlant.map((org) => ({
        value: org,
        label: org,
      }));
      setPlant(options);
    }
  }, [plantStorageData]);

  useEffect(() => {
    if (!selectedSalesOrg) return;

    const distChannelTemp = Array.from(
      new Set(
        sapOrderConfigData
          .filter((i) => i.SalesOrg === selectedSalesOrg)
          .map((i) => i.DistChannel)
      )
    ).map((dc) => ({ value: dc, label: dc }));

    setDistChannel(distChannelTemp);
  }, [selectedSalesOrg, sapOrderConfigData]);

  useEffect(() => {
    if (selectedDistChannel) {
      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === selectedSalesOrg &&
                i.DistChannel === selectedDistChannel
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setDivision(divisionTemp);
    }
  }, [selectedDistChannel]);

  useEffect(() => {
    if (id) {
      dispatch(getReturnSalesOrderByIdData({ id }));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (detailsData) {
      setDetail(detailsData);
    }
  }, [detailsData]);
  // // // console.log({ detail }, 'detail');

  if (returnSalesOrderLoader) {
    return <Loader />;
  }
  const submitOrderToSap = (orderDetails: any) => {
    // // console.log(orderDetails,"orderDetails");
    const finalData = prepareReturnOrderData(orderDetails);
    // // console.log(finalData,"finalData");
    // // console.log(orderDetails._id,"orderDetails");
    // return
    dispatch(
      createReturnSalesOrderData({ data: finalData, id: orderDetails?._id })
    ).then((res) => {
      // // // console.log({ res }, 'res');
      if (res && res.payload && res.payload.status) {
        // setOpenModal(false);
        toast.success(res.payload.message);
        dispatch(getReturnSalesOrderByIdData({ id }));

        // dispatch(
        //   getReturnSalesOrderData({
        //     page: pageIndex,
        //     limit: pageSize,
        //     status: orderType,
        //     order_type: orderStatus,
        //   })
        // );
      }
    });
  };

  const handlereject = () => {
    dispatch(
      updateReturnSalesOrderData({
        id: detail?._id,
        data: { status: "reject" },
      })
    ).then((res) => {
      // // // console.log({ res });
      if (res && res.payload && res.payload.status) {
        // setOpenModal(false);
        // dispatch(getReturnSalesOrderData({ page: pageIndex, limit: pageSize }));
        // setUpdate(!update);
        setDetail({
          ...detail,
          status: "reject",
        });
        toast.success(res.payload.message);
        // setOpenModal(false);
      }
      // setOpenModal(false);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox
        sx={{
          padding: "15px",
          backgroundColor: "#fff",
          boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        }}
      >
        <SoftBox
          sx={{
            fontSize: "18px",
            fontWeight: "700",
            lineHeight: "normal",
            paddingBottom: "20px",
            marginBottom: "20px",
            borderRadius: "0px",
            borderBottom: "1px solid #ccc",
          }}
        >
          {`${detail?.user_id?.owner_name + "'s" || ""} Order Request`}
        </SoftBox>

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Business Partner No: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.BusPartner || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              tag="h3"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Name: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.user_id?.owner_name || "N/A"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Return Order Reason: &nbsp;
            </SoftTypography>
            <SoftTypography
              variant="button"
              fontWeight="regular"
              color="text"
              textTransform="capitalize"
            >
              &nbsp;{detail?.ReturnOrderReason || "N/A"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Status: &nbsp;
            </SoftTypography>
            <SoftBadge
              variant="gradient"
              badgeContent={detail?.status}
              color={
                detail?.status === "pending"
                  ? "info"
                  : detail?.status === "reject"
                  ? "error"
                  : "success"
              }
              size="xs"
            />
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Sales Order: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.SalesOrder || "N/A"}
            </SoftTypography>
          </SoftBox>
        </SoftBox>

        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Return Reason: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.ReturnReason || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Req Date: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{new Date(detail?.ReqDate).toLocaleDateString("en-GB")}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Return Code: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{detail?.ReturnCode || "N/A"}
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              paddingBottom: "10px",
              marginBottom: "0px",
              borderBottom: "1px solid #ccc",
              borderRadius: "0px",
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Return Date: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              &nbsp;{new Date(detail?.ReturnDate).toLocaleDateString("en-GB")}
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={1}
        >
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Doc Type: &nbsp;
            </SoftTypography>
            <SoftTypography variant="button" fontWeight="regular" color="text">
              <SoftInput
                value={detail?.DocType || "N/A"}
                onChange={(e) =>
                  setDetail({
                    ...detail,
                    DocType: e.target.value,
                  })
                }
              />
            </SoftTypography>
          </SoftBox>
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Sale Organization: &nbsp;
            </SoftTypography>
            <Select
              id="demo-simple-select"
              name="SalesOrg"
              value={selectedSalesOrg}
              onChange={(e) => {
                setSelectedSalesOrg(e.target.value);
                setDetail({
                  ...detail,
                  SalesOrg: e.target.value,
                });
              }}
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              {salesOrg &&
                salesOrg.length > 0 &&
                salesOrg.map((item: any) => {
                  return <MenuItem value={item.value}>{item.label}</MenuItem>;
                })}
            </Select>
          </SoftBox>
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Division: &nbsp;
            </SoftTypography>
            <Select
              value={selectedDivision}
              onChange={(e) => {
                setSelectedDivision(e.target.value);
                setDetail({
                  ...detail,
                  Division: e.target.value,
                });
              }}
              id="demo-simple-select"
              name="division"
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              {division &&
                division.map((item: any, index: number) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
            </Select>
          </SoftBox>
          <SoftBox
            sx={{
              width: {
                sm: "100%",
                md: "48%",
              },
            }}
          >
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Dist. Channel: &nbsp;
            </SoftTypography>
            <Select
              value={selectedDistChannel}
              onChange={(e) => {
                setSelectedDistChannel(e.target.value);
                setDetail({
                  ...detail,
                  DistChannel: e.target.value,
                });
              }}
              id="demo-simple-select"
              name="distChannel"
              IconComponent={KeyboardArrowDownIcon}
              fullWidth
              size="small"
              sx={{
                padding: "0px 8px !important",
                height: "40px !important",
                display: "block !important",
                ".MuiSelect-select": {
                  padding: "0px 8px !important",
                  height: "40px !important",
                },
                ".MuiSelect-nativeInput": {
                  height: "40px !important",
                },
                ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
                ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                  display: "block !important",
                  fontSize: "1.25rem !important",
                },
              }}
            >
              {distChannel &&
                distChannel.map((item: any, index: number) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
            </Select>
          </SoftBox>
        </SoftBox>
        <SoftBox pb={2}>
          {detail?.image_urls && detail?.image_urls.length > 0 && (
            // detail?.image_urls.map((image_url: string, index: number) => (
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Images:
              </SoftTypography>
              <SoftTypography
                px={1}
                variant="button"
                fontWeight="regular"
                color="text"
              >
                <FaEye
                  style={{
                    cursor: "pointer",
                    height: "25px",
                    width: "25px",
                    color: "#1b3648",
                    padding: "3px",
                    border: "1px solid #1b3648",
                    borderRadius: "5px",
                  }}
                  onClick={() => setOpenGallery(true)}
                  fontSize={20}
                />
              </SoftTypography>
            </SoftBox>
          )}
        </SoftBox>
        <SoftBox
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
          pb={2}
        >
          {/* <SoftTypography
            variant="button"
            fontWeight="bold"
            textTransform="capitalize"
          >
            Material Details: &nbsp;
          </SoftTypography> */}
          <TableContainer
            className="table-container"
            sx={{ padding: "0px", borderRadius: "0px" }}
          >
            <Table
              sx={{ Width: "100%" }}
              className="w3-table-all"
              aria-label="Order Material List table"
            >
              <TableHead>
                <TableRow>
                  <TableCell>Batch</TableCell>
                  <TableCell>Item No</TableCell>
                  <TableCell>Material</TableCell>
                  <TableCell>NetValue</TableCell>
                  <TableCell>OrderQty</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Req Date</TableCell>
                  <TableCell>Sales Order</TableCell>
                  <TableCell>Store Loc</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detail?.NavHeaderToItem &&
                  detail?.NavHeaderToItem?.length &&
                  detail?.NavHeaderToItem.map(
                    (item: IOrderItem, index: number) => (
                      <TableRow key={"order-item-" + index}>
                        <TableCell>{item.Batch}</TableCell>
                        <TableCell>{item.ItemNo}</TableCell>
                        <TableCell>{item.Material}</TableCell>
                        <TableCell>{item.NetValue}</TableCell>
                        <TableCell>
                          <SoftInput
                            value={item.OrderQty}
                            onChange={(e) =>
                              setDetail({
                                ...detail,
                                NavHeaderToItem: detail?.NavHeaderToItem.map(
                                  (item: any, i: number) =>
                                    index === i
                                      ? { ...item, OrderQty: e.target.value }
                                      : item
                                ),
                              })
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Select
                            value={item.Plant}
                            onChange={(e) => {
                              const newPlant = e.target.value;
                              // Find store locations for this plant
                              const storLocTemp = Array.from(
                                new Set(
                                  plantStorageData
                                    .filter((i) => i.Plant === newPlant)
                                    .map((i) => i.StorLoc)
                                )
                              ).map((dc) => ({ value: dc, label: dc }));

                              setStorLocs((prev) => ({
                                ...prev,
                                [index]: storLocTemp,
                              }));

                              setDetail({
                                ...detail,
                                NavHeaderToItem: detail?.NavHeaderToItem.map(
                                  (itm: any, i: number) =>
                                    index === i
                                      ? {
                                          ...itm,
                                          Plant: newPlant,
                                          StoreLoc: storLocTemp[0]?.value || "",
                                        }
                                      : itm
                                ),
                              });
                            }}
                            id="demo-simple-select"
                            name="Plant"
                            style={{ width: "100%" }}
                          >
                            {plant &&
                              plant.length > 0 &&
                              plant.map((p: any, idx: number) => (
                                <MenuItem value={p.value} key={idx}>
                                  {p.label}
                                </MenuItem>
                              ))}
                          </Select>
                        </TableCell>
                        <TableCell>
                          {item.ReqDate
                            ? new Date(item.ReqDate).toLocaleDateString("en-GB")
                            : "N/A"}
                        </TableCell>
                        <TableCell>{item.SalesOrder}</TableCell>
                        <TableCell>
                          <Select
                            value={item.StoreLoc}
                            onChange={(e) => {
                              setDetail({
                                ...detail,
                                NavHeaderToItem: detail?.NavHeaderToItem.map(
                                  (itm: any, i: number) =>
                                    index === i
                                      ? { ...itm, StoreLoc: e.target.value }
                                      : itm
                                ),
                              });
                            }}
                            id="demo-simple-select"
                            name="storLoc"
                            style={{ width: "100%" }}
                          >
                            {storLocs[index] && storLocs[index].length > 0 ? (
                              storLocs[index].map((loc: any, idx: number) => (
                                <MenuItem value={loc.value} key={idx}>
                                  {loc.label}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="">No Store Location</MenuItem>
                            )}
                          </Select>
                        </TableCell>
                      </TableRow>
                    )
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </SoftBox>
        <SoftBox py={2}>
          {detail?.ReturnOrderNo && (
            <p style={{ fontSize: 16, marginRight: "14px" }}>
              This Return Order is Submited to Sap. Return Order No:{" "}
              {detail?.ReturnOrderNo}
            </p>
          )}
        </SoftBox>
        <SoftBox display="flex" alignContent={"center"} justifyContent={"end"}>
          <SoftButton
            className="modal_cancel modal_btn"
            disabled={detail?.status !== "pending"}
            onClick={() => handlereject()}
          >
            Reject
          </SoftButton>
          <SoftButton
            className="modal_btn"
            disabled={detail?.ReturnOrderNo || detail?.status !== "pending"}
            onClick={() => submitOrderToSap(detail)}
          >
            Send To SAP
          </SoftButton>
        </SoftBox>
      </SoftBox>
      <Modal open={openGallery} onClose={() => setOpenGallery(false)}>
        <SoftBox
          bgColor="white"
          p={2}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          {detail?.image_urls && detail?.image_urls.length > 0 && (
            <ImageGallery
              items={detail?.image_urls.map((image) => ({
                original: image,
                thumbnail: image,
              }))}
              showThumbnails={true}
              showPlayButton={false}
              showFullscreenButton={true}
            />
          )}
        </SoftBox>
      </Modal>
    </DashboardLayout>
  );
};

export default ViewReturnSalesOrder;
